__turbopack_context__.v({
  "className": "cinzel_a0864f19-module__BTC6_q__className",
});
